export const ROLE_LABELS = {
  customer: "Customer",
  affiliate: "Affiliate",
  driver: "Driver",
  partner: "Partner",
  franchisee: "Franchisee",
  trainer: "Trainer",
  teacher: "Teacher",
  affiliate_trainer: "Affiliate Trainer",
  franchisee_trainer: "Franchisee Trainer",
  training_admin: "Training Admin",
  admin: "Admin",
  master_admin: "Master Admin",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS);

export function hasPermission(perms, required) {
  if (!perms || !required) return false;
  if (perms.includes("*")) return true;
  if (perms.includes(required)) return true;
  const mod = required.split(":")[0];
  return perms.includes(`${mod}:*`);
}

export function hasRole(user, role) {
  return !!user?.roles?.includes(role);
}
